export const AdjustmentReasonCode = {
    BONUS_END_OF_YEAR: 'BONUS_END_OF_YEAR',
    SLA_PENALTY: 'SLA_PENALTY',
    HOLIDAY_SURCHARGE: 'HOLIDAY_SURCHARGE',
    PROMOTION_DISCOUNT: 'PROMOTION_DISCOUNT',
    EQUIPMENT_DAMAGE: 'EQUIPMENT_DAMAGE',
    EXTRA_SERVICE: 'EXTRA_SERVICE',
    CUSTOMER_COMPLAINT: 'CUSTOMER_COMPLAINT',
    REFUND: 'REFUND',
    OTHER: 'OTHER'
} as const;

export type AdjustmentReasonCodeType = typeof AdjustmentReasonCode[keyof typeof AdjustmentReasonCode];

export interface AdjustmentReasonCodeInfo {
    value: string;
    label: string;
    description: string;
    defaultType: 'increase' | 'decrease' | 'both'; // + hoặc - hoặc +/-
}

export const getAdjustmentReasonCodeInfo = (code: string): AdjustmentReasonCodeInfo | null => {
    switch (code) {
        case AdjustmentReasonCode.BONUS_END_OF_YEAR:
            return {
                value: AdjustmentReasonCode.BONUS_END_OF_YEAR,
                label: 'Bonus cuối năm',
                description: 'Thưởng cho đối tác hoạt động tốt',
                defaultType: 'increase'
            };
        case AdjustmentReasonCode.SLA_PENALTY:
            return {
                value: AdjustmentReasonCode.SLA_PENALTY,
                label: 'Phạt vi phạm SLA',
                description: 'Phạt khi không đạt chỉ tiêu dịch vụ',
                defaultType: 'decrease'
            };
        case AdjustmentReasonCode.HOLIDAY_SURCHARGE:
            return {
                value: AdjustmentReasonCode.HOLIDAY_SURCHARGE,
                label: 'Phụ phí ngày lễ',
                description: 'Thu thêm phí hoạt động ngày lễ',
                defaultType: 'increase'
            };
        case AdjustmentReasonCode.PROMOTION_DISCOUNT:
            return {
                value: AdjustmentReasonCode.PROMOTION_DISCOUNT,
                label: 'Giảm giá khuyến mãi',
                description: 'Giảm phí trong chương trình khuyến mãi',
                defaultType: 'decrease'
            };
        case AdjustmentReasonCode.EQUIPMENT_DAMAGE:
            return {
                value: AdjustmentReasonCode.EQUIPMENT_DAMAGE,
                label: 'Phí hư hại thiết bị',
                description: 'Phạt khi làm hỏng thiết bị',
                defaultType: 'decrease'
            };
        case AdjustmentReasonCode.EXTRA_SERVICE:
            return {
                value: AdjustmentReasonCode.EXTRA_SERVICE,
                label: 'Dịch vụ bổ sung',
                description: 'Phí dịch vụ thêm',
                defaultType: 'increase'
            };
        case AdjustmentReasonCode.CUSTOMER_COMPLAINT:
            return {
                value: AdjustmentReasonCode.CUSTOMER_COMPLAINT,
                label: 'Khiếu nại khách hàng',
                description: 'Bồi thường do khách hàng khiếu nại',
                defaultType: 'decrease'
            };
        case AdjustmentReasonCode.REFUND:
            return {
                value: AdjustmentReasonCode.REFUND,
                label: 'Hoàn tiền',
                description: 'Hoàn lại tiền cho booking bị hủy',
                defaultType: 'decrease'
            };
        case AdjustmentReasonCode.OTHER:
            return {
                value: AdjustmentReasonCode.OTHER,
                label: 'Khác',
                description: 'Lý do khác',
                defaultType: 'both'
            };
        default:
            return null;
    }
};

export const getAdjustmentReasonCodeLabel = (code: string): string => {
    const info = getAdjustmentReasonCodeInfo(code);
    return info ? info.label : code;
};

export const getAdjustmentReasonCodeDescription = (code: string): string => {
    const info = getAdjustmentReasonCodeInfo(code);
    return info ? info.description : '';
};

export const getAllAdjustmentReasonCodes = (): Array<AdjustmentReasonCodeInfo> => {
    return [
        getAdjustmentReasonCodeInfo(AdjustmentReasonCode.BONUS_END_OF_YEAR)!,
        getAdjustmentReasonCodeInfo(AdjustmentReasonCode.SLA_PENALTY)!,
        getAdjustmentReasonCodeInfo(AdjustmentReasonCode.HOLIDAY_SURCHARGE)!,
        getAdjustmentReasonCodeInfo(AdjustmentReasonCode.PROMOTION_DISCOUNT)!,
        getAdjustmentReasonCodeInfo(AdjustmentReasonCode.EQUIPMENT_DAMAGE)!,
        getAdjustmentReasonCodeInfo(AdjustmentReasonCode.EXTRA_SERVICE)!,
        getAdjustmentReasonCodeInfo(AdjustmentReasonCode.CUSTOMER_COMPLAINT)!,
        getAdjustmentReasonCodeInfo(AdjustmentReasonCode.REFUND)!,
        getAdjustmentReasonCodeInfo(AdjustmentReasonCode.OTHER)!,
    ];
};

